// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"d784506f","133":"9a4f4f1a","182":"cecb3e1f"}[chunkId] + ".chunk.js";
};